/*
 * File Description: ping Sign Up redirect handler
 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import querystring from 'query-string';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import HeaderFooterwithCookies from '../../common/openPages/HeaderFooterwithCookies';
import PingRedirectCard from '../PingLogin/PingRedirectCard';

// ACTION: backend POST /verifypingUser
import { verifypingSignUp } from '../../../containers/actions/authActions';

class PingSignUpRedirect extends Component {
  state = { tokenError: null };

  componentDidMount() {
    const { search } = this.props.location;
    const parsed = querystring.parse(search);

    const pingCode = parsed.code; // from ping
    const signUpToken = parsed.state;  // your invite token carried in state

    this.props.verifypingSignUp(
      { pingCode, signUpToken },
      this.props.history,
      signUpToken
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.invitedUserData !== this.props.invitedUserData &&
      this.props.invitedUserData?.status === false
    ) {
      this.setState({
        tokenError: this.props.invitedUserData.errorDescription,
      });
    }
  }

  render() {
    const { tokenError } = this.state;
    return (
      <HeaderFooterwithCookies>
        {tokenError ? (
          <Grid
            container
            alignItems="center"
            justify="center"
            style={{ textAlign: 'center', marginTop: 100 }}
          >
            <Grid item xs={12}>
              <Typography variant="body1" style={{ marginTop: '3rem', fontWeight: 500 }}>
                {tokenError}
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: '1rem' }}>
              <Typography
                variant="body2"
                color="primary"
                style={{ display: 'inline', textDecoration: 'underline', cursor: 'pointer', fontSize: '1rem' }}
                component={Link}
                to="/contactadmin"
              >
                Contact the ecosystem administrator for an invitation
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <PingRedirectCard />
        )}
      </HeaderFooterwithCookies>
    );
  }
}

const mapStateToProps = (state) => ({
  invitedUserData: state.auth.invitedUserData,
});

export default connect(mapStateToProps, { verifypingSignUp })(
  withRouter(PingSignUpRedirect)
);
